<div class="live-line-row"
     [class]="stateClass()"
     [class.is-running]="isRunning()"
     [class.is-best-score]="isBestScore()"
     (click)="onClick()"
     data-testid="live-line-row">
  <span class="dot" [matTooltip]="stateTooltip()"></span>

  <div class="main">
    <div class="title-row">
      <span class="title">{{ ligne().ligneDenomination }}</span>
      @if (ligne().currentOf) {
        <span class="of">· {{ ligne().currentOf!.numero }}</span>
        @if (initiales()) {
          <span class="conducteur"
                [style.background-color]="conducteurColor()"
                [matTooltip]="conducteursLabel()">
            {{ initiales() }}
          </span>
        }
        @if (hasMachine()) {
          <span class="device-status"
                [class.online]="deviceOnline()"
                [class.offline]="!deviceOnline()"
                [matTooltip]="deviceOnline() ? 'Automate connecté' : 'Automate déconnecté (pas de trame depuis plus de 5 min)'">
            <mat-icon class="device-icon">router</mat-icon>
            <span class="device-status-dot"></span>
          </span>
        }
        @if (isBestScore()) {
          <mat-icon class="trophy-icon"
                    matTooltip="Best score : durée sans arrêt = record session">
            emoji_events
          </mat-icon>
        }
      }
    </div>

    @if (ligne().currentOf) {
      <div class="subtitle">
        <span class="ellipsis">{{ ligne().currentOf!.articleDenomination ?? '—' }}</span>
      </div>
      @if (etapeShortLabel()) {
        <div class="etape-line"
             [matTooltip]="etapeFullLabel()">
          @if (ligne().currentOf!.currentEtape; as e) {
            <span class="etape-pill">{{ e.index }}/{{ e.total }}</span>
          } @else {
            <mat-icon class="etape-icon">arrow_forward</mat-icon>
          }
          <span class="ellipsis etape-text">{{ etapeShortLabel() }}</span>
        </div>
      }
      <div class="progress-wrap" [matTooltip]="ligne().currentOf!.quantiteProduite + ' / ' + ligne().currentOf!.quantite">
        <div class="progress" [style.width.%]="progressPct()"></div>
      </div>
    } @else if (ligne().nextOf && nextOfDelayLabel()) {
      <div class="subtitle">
        <span class="ellipsis">Prochain : {{ ligne().nextOf!.numero }} · {{ nextOfDelayLabel() }}</span>
      </div>
    } @else if (reprisePrevueLabel()) {
      <div class="subtitle">
        <span class="ellipsis">Reprise {{ reprisePrevueLabel() }}</span>
      </div>
    } @else {
      <div class="subtitle muted">{{ stateLabel() }}</div>
    }
  </div>

  <div class="kpis">
    @if (cadenceUH() != null) {
      <div class="cadence" [class]="'cadence-' + cadenceVsCible()">
        <span class="cadence-value">{{ cadenceUH() }}</span>
        <span class="cadence-unit">u/h</span>
      </div>
    } @else if (ligne().currentOf) {
      <div class="cadence cadence-neutral">
        <span class="cadence-value">{{ ligne().currentOf!.quantiteProduite | number:'1.0-0':'fr-FR' }}</span>
        <span class="cadence-unit">u</span>
      </div>
    } @else {
      <span class="cadence-empty">—</span>
    }
  </div>
</div>
